import './ExtraServicesBlock.scss';
import extraServicesData from './extra-services-data';
import classNames from 'classnames';

const ExtraServicesBlock = () => {
   

    return (
        <section className='extra-services-block'>
            <div className='extra-services-block-container'>
                <h2>extra <br/> services</h2>

                <div className='extra-services-info-box'>
                    {
                        extraServicesData.map((item, index) => (
                            <div className='extra-services-item' key={index}>
                                <p className={classNames('extra-services-item-text', {
                                    item_4: item.id === 4,
                                    item_5: item.id === 5,
                                    item_6: item.id === 6,
                                })}>{item.name}</p>

                                <span className={classNames('extra-services-item-price', {
                                    hidden: item.price === '0',
                                    nda: item.id === 9
                                })}>{item.price}</span>
                            </div>
                        ))
                    }
                </div>

            </div>
        </section>
    )
}

export default ExtraServicesBlock
